import React, {Component} from 'react';
import StandardCRUD from "../../../components/StandardCRUD" //component that used for standard crud from

import data_field from './_field'; // fields form
import SidebarDataMaster from '../SidebarDataMaster';
import SectionDataView from '../../../containers/_layout/SectionDataView';
import broker from '../../../utils/broker'

class User extends Component {
  constructor(props) {
    super(props);

    this.options = {
      sortIndicator: true,
      hideSizePerPage: true,
      paginationSize: 6,
      hidePageListOnlyOnePage: true,
      clearSearch: true,
      alwaysShowAllBtns: false,
      withFirstAndLast: false
    }
    this.state = {
      reload:false,
      loading: false,
      id_pk_column: 'id',
      data_kategori : [],
      checkbox_data : {},
      user_id: null,
      url: { url_get_data : '/user', url_save_data: '/user', url_update_data: '/user',  // definition url endpoint of crud that will be used
             url_delete_data: '/user', url_get_data_per: '/user' },
      title: 'Master User', // title list
      title_add : 'Add Data Master User', //title form add
      fields: data_field.data, //this field used for data input (save & delete)
      columns: [ // this for data table, definition column you want to show
        { header: 'Nama', id: 'nama_lengkap', accessor: 'nama_lengkap', child_accessor: null, className: 'text-center'},
        { header: 'Username', id: 'username', accessor: 'username', child_accessor: null, className: 'text-center'},
        { header: 'Role', id: 'role', accessor: 'role', child_accessor: null, className: 'text-center'},
        { header: 'Kategori', id: 'id', accessor: 'id', child_accessor: null,
            Cell: row => {
                return <a href="#modal_view" data-toggle="modal" className="btn btn-xs pd-x-10 btn-outline-dark btn-uppercase mg-l-5"
                            onClick={() => this.getDataKategori(row.row.id)}>
                            <i className="fa fa-list"></i>
                        </a>;
            }
        },
        
        { header: 'Status', id: 'status', accessor: 'status', child_accessor: null,
            Cell: row => {
                return <span className={(row.row.status === 'AKTIF') ? 'badge badge-light' : 'badge badge-dark'}>{row.row.status}</span>
                }
        },
    ],
    }
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  getDataKategori(id) {
    let checkbox = {};
    this.setState({user_id : id});
    broker.fetch.get(`data/user/${id}/kategori_outer`)
      .then(res => {
          const { data } = res.data;
          if (data) {
              this.setState({data_kategori : data}, function(){
                  var data_kategori = this.state.data_kategori;
                  for (var i=0; i<data_kategori.length; i++){
                      checkbox[data[i].id_1] = (data[i].id_2) ? true : false
                  }
                  this.setState({checkbox_data : checkbox})
              })
          } else {

          }
      }).catch(err => {
          
      });
  }

  handleInputChange(event) {
    var checked = event.target.checked;
    var id = event.target.id;

    var checkbox_data = this.state.checkbox_data;

    for (var key in checkbox_data){
        if (key === id){
          checkbox_data[key] = checked
        }
    }

    this.setState({checkbox_data : checkbox_data});

    var body = {user_id : this.state.user_id, kategori_id : id}

    var url = (checked) ? 'user_kategori' : 'user_kategori_delete';

    broker.fetch.post(`${url}`, body)
    .then(res => {
        const { data } = res.data;
        if (data) {
            
        } else {

        }
    }).catch(err => {
        
    });

  }

  render() {
    // console.log(this.state.checkbox_data)
    return (
      <React.Fragment>
        <SidebarDataMaster location={this.props.location.pathname}/>
        <StandardCRUD 
              columns={this.state.columns} 
              url={this.state.url} 
              title={this.state.title} 
              title_add={this.state.title_add} 
              fields={this.state.fields} 
              id_pk={null} 
              add_form={true}
              id_pk_column={this.state.id_pk_column}
              style_container="content content-components"
              search_query=""
              search_column={true}
        />
        <div className="modal fade effect-scale" id="modal_view" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel2" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content tx-14">
              <div className="modal-header">
                <h6 className="modal-title" id="exampleModalLabel2">Daftar Kategori</h6>
                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="mg-sm-l-30">
                  {(this.state.data_kategori) &&
                      this.state.data_kategori.map((data, i) => {
                          return  <div className="custom-control custom-checkbox pd-b-10" key={i}>
                                    <input type="checkbox" className="custom-control-input" id={data.id_1} 
                                          checked={this.state.checkbox_data[data.id_1] || ''}
                                          onChange={this.handleInputChange} />
                                    <label className="custom-control-label" htmlFor={data.id_1}>{data.nama}</label>
                                  </div>
                      })
                  }

                </div>
              </div>
            </div>
          </div>
        </div>
       <SectionDataView />
      </React.Fragment>
      
    );
  }
}

export default User;
